<template>
  <div class="container our-plans">
    <h1 class="text-center my-5">{{ $t("landing.our_products.title") }}</h1>

    <div class="row light">
      <div class="col-4">
        <span class="plan-header">{{
          $t("landing.our_products.plan_1.plan")
        }}</span>
        <h2>{{ $t("landing.our_products.plan_1.title") }}</h2>
        <hr class="divider" />
        <p>{{ $t("landing.our_products.plan_1.description") }}</p>
        <router-link
          :to="{
            name: 'checkout',
            params: { cycle: 'monthly', plan: 'basic' },
          }"
          custom
          v-slot="{ navigate }"
        >
          <button
            @click="navigate"
            role="link"
            class="button-plan-cta btn-danger"
          >
            {{ $t("landing.our_products.plan_1.button") }}
          </button>
        </router-link>
      </div>
      <div class="col-4"></div>
      <div class="col-4 c-right">
        <span class="plan-header">{{
          $t("landing.our_products.plan_2.plan")
        }}</span>
        <h2>{{ $t("landing.our_products.plan_2.title") }}</h2>
        <hr class="divider" />
        <p>{{ $t("landing.our_products.plan_2.description") }}</p>
        <router-link
          :to="{
            name: 'checkout',
            params: { cycle: 'monthly', plan: 'premium' },
          }"
          custom
          v-slot="{ navigate }"
        >
          <button @click="navigate" role="link" class="button-plan-cta">
            {{ $t("landing.our_products.plan_2.button") }}
          </button>
        </router-link>
      </div>
    </div>
    <router-link :to="$t('routes.plans')" class="plans">
      {{ $t("landing.our_products.plans") }}
    </router-link>
    <hr class="divider" />
  </div>
</template>

<script>
export default {
  name: "OurProducts",
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.webp {
  .our-plans {
    .divider {
      background: url("@/assets/img/divider-line.webp") no-repeat top center;
      background-size: contain;
    }
    .light {
      background: url("@/assets/img/our-products/background2.webp") no-repeat
        top center;
      background-size: cover;
    }
  }
}
.our-plans {
  .plan-header {
    background: rgba(0, 0, 0, 0.5);
    color: $purple;
    font-size: 1.2em;
    font-weight: 500;
    display: block;
    border: 1px solid $purple;
    border-top: 1px solid $purple-trans;
    border-right: 1px solid $purple-trans;
    width: 12em;
    text-align: center !important;
    padding: 0.7em;
    border-radius: 12px;
    margin-bottom: 2em;
  }
  .plans {
    display: block;
    text-align: center;
    color: $gray-2;
    text-decoration: underline;
    margin: 2em auto;
  }
  .divider {
    background: url("@/assets/img/divider-line.png") no-repeat top center;
    background-size: contain;
    width: 100%;
    height: 10px;
    margin: 3em auto;
  }
  .light {
    background: url("@/assets/img/our-products/background2.svg") no-repeat top
      center;
    background-size: cover;
    padding: 0 1em 7em;
    button {
      background: $red;
      padding: 1em;
      width: 100%;
      border-radius: 14px;
      text-align: center !important;
      transition: background-color 0.3s, border-color 0.3s;
      border: 1px solid transparent;
      &:hover {
        border: 1px solid white;
      }
    }
    h2 {
      font-size: 1.3em;
      width: 70%;
    }
    p {
      color: $gray-2;
      font-size: 1em;
    }
    .divider {
      background: url("@/assets/img/divider-short.png") no-repeat top center;
      background-size: contain;
      width: 5em;
      height: 5px;
      margin: 0.5em 0 1em;
    }
    .c-right {
      .plan-header {
        float: right;
        color: $pink;
        border: 1px solid $pink;
        border-top: 1px solid $pink-trans;
        border-right: 1px solid $pink-trans;
      }
      * {
        text-align: right;
      }
      .divider {
        float: right;
        clear: both;
      }
      h2 {
        float: right;
      }
      p {
        clear: both;
      }
      button {
        background: none;
        border: 1px solid white;
        &:hover {
          background: $red;
        }
      }
    }
    @media (min-width: 992px) and (max-width: 1024px) {
      padding: 5em 1em;
    }
    @media (min-width: 768px) and (max-width: 991px) {
      padding: 7.3em 1em;
      border-radius: 14px;
    }
  }
  
  @media (min-width: 1920px) {
    &.container{
      width: 65%;
      max-width: none;
    }
    font-size: 0.88vw;
  }
}
</style>
